/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { IapComponent } from "../../../component/domain/iapComponent";
import { LocalService } from "../../../../../common/infrastructure/servicios";
import { ExpresionEngine } from "../../../expression/infrastructure/helper/expressionEngine";
import HelperLoading from "../../../../../common/infrastructure/funciones/HelperLoading";
import { Container } from "inversify";
import { IapWorkFlowActivity } from "../../domain/service/iapWorkFlowActivity";
import { IServiceWorkFlowActivity } from "../../application/interface/IServiceWorkFlowActivity";
import { TYPES } from "../../../../../common/domain/types";
import { IServiceWorkFlowActivityConnection } from "../../application/interface/IServiceWorkFlowActivityConnection";
import { IapWorkFlowActivityConnection } from "../../domain/service/iapWorkFlowActivityConnection";
import { IapWorkFlow } from "../../domain/service/iapWorkFlow";
import { IapWorkFlowActivityVariable } from "../../domain/service/iapWorkFlowActivityVariable";
import { Dictionary } from "../../../expression/domain/dictionary";
import { IServiceWorkFlowActivityVariable } from "../../application/interface/IServiceWorkFlowActivityVariable";
import { IapWorkFlowActivityControl } from "../../domain/service/iapWorkFlowActivityControl";
import { IServiceWorkFlowActivityControl } from "../../application/interface/IServiceWorkFlowActivityControl";
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";
import CatalogObjectTypeConst from "../../../catalog/domain/const/CatalogObjectTypeConst";
import { ProcedureData } from "../../../search/domain/procedureData";
import { IapComponentAttribute } from "../../../component/domain/iapComponentAttribute";


export default function HelperCustomComponentControls
  (
    dataInput:any
  ) {


  

    const showExpression = (variableName: string, header:string,item : null |  ProcedureData | IapComponentAttribute = null) => {
        if (dataInput) {
            const data = dataInput.getNode(variableName)
            if (data) {
                let  objectDescription = header;
                let objetoId = data['id']?.toString()
                if (objetoId) {
                    const idObjeto = CatalogObjectTypeConst.WFAC;
                    //objetoId += '#'+ variableName + '=' + item.id;
                    if (item &&  (item as any).parameterName )
                    {
                      objetoId += '#parameterName=' + (item as ProcedureData).parameterName
                    }
                    if (item &&  (item as any).idAttributeType )
                    {
                      objetoId += '#parameterId=' + (item as IapComponentAttribute).id;                     
                    }
                    
                    
                    dataInput.showExpression({ objetoId: objetoId, idObjeto: idObjeto, description: objectDescription })
                }
            }
        }
    }

    
  return {
    showExpression
  };
}
